import { StyledFieldTooltipContent } from './FieldTooltipContent.styles';

export interface FieldTooltipContentProps {
  img: string;
  alt: string;
  text: string;
}

export const FieldTooltipContent = ({ img, alt, text }: FieldTooltipContentProps): JSX.Element => (
  <StyledFieldTooltipContent>
    <img src={img} alt={alt} className="field-tooltip-content__img" />
    <p className="field-tooltip-content__text">{text}</p>
  </StyledFieldTooltipContent>
);
